module.exports = __webpack_public_path__ + "img/ZonaMate_icone_GeoGebra_bianca.2e28f7ca.svg";